import { useCifraClient } from "./cifra-client";

const { cifraClient } = useCifraClient();

export const URL = '/api_publica/v1/usuarios';
export const URL_SELECTOR = '/api_publica/v1/usuarios/selector';
export const URL_PARENTESCOS = '/api_publica/v1/usuarios/parentescos';
import * as utilsUsuario from '@/libs/usuarios';

export default {
  list(options) {
    return cifraClient.get(URL, options);
  },
  show(id, options) {
    return cifraClient.get(`${URL}/${id}`, options);
  },
  parentescos(usuarioActualId, options) {
    return cifraClient.post(URL_PARENTESCOS, { usuario_id: usuarioActualId }, options);
  },
  ...utilsUsuario,
};
